document.addEventListener('DOMContentLoaded', function () {

  // Open Responsive Header

  const btn = document.querySelector('button.hamburger_btn');
  btn.addEventListener('click', function () {
    const megaMenu = document.querySelector('aside.responsive-header');

    if (!megaMenu.classList.contains('show')) {
      // menu open karo
      this.querySelector('.open_svg').style.display = 'none';
      this.querySelector('.close_svg').style.display = 'inline-flex';
      megaMenu.classList.add('show');
      document.querySelector('body').style.overflow = 'hidden';
    } else {
      // menu close karo
      this.querySelector('.open_svg').style.display = 'inline-flex';
      this.querySelector('.close_svg').style.display = 'none';
      megaMenu.classList.remove('show');
      document.querySelector('body').style.overflow = '';
    }
  });

  // // Search results

  // const input = document.querySelector('.search-popup__input');
  // const productsWrap = document.querySelector('.search-popup__products');
  // const pagesWrap = document.querySelector('.search-popup__suggestions-page');
  // const blogsWrap = document.querySelector('.search-popup__suggestions--blog');

  // if (!input) return;

  // let controller;

  // input.addEventListener('input', () => {
  //   const q = input.value.trim();

  //   // clear state
  //   if (q.length < 2) {
  //     productsWrap.innerHTML = '';
  //     pagesWrap.innerHTML = '';
  //     blogsWrap.innerHTML = '';
  //     return;
  //   }

  //   if (controller) controller.abort();
  //   controller = new AbortController();

  //   fetch(
  //     `/search/suggest.json?q=${encodeURIComponent(q)}&resources[type]=product,page,article&resources[limit]=8`,
  //     { signal: controller.signal }
  //   )
  //   .then((res) => res.json())
  //   .then((data) => {
  //     const results = data.resources?.results || {};
  //     const products = results.products || [];
  //     const pages = results.pages || [];
  //     const articles = results.articles || [];

  //     /* 🔹 PRODUCTS */
  //     productsWrap.innerHTML = products
  //       .map(
  //         (p) => `
  //             <a href="${p.url}" class="search-popup__product">
  //               ${
  //                 p.image
  //                   ? `
  //                 <div class="search-popup__product-image">
  //                   <img src="${p.image}" alt="${p.title}">
  //                 </div>`
  //                   : ''
  //               }
  //               <span class="search-popup__product-title">${p.title}</span>
  //             </a>
  //           `
  //       )
  //       .join('');

  //     /* 🔹 PAGES */
  //     pagesWrap.innerHTML = pages
  //       .map(
  //         (p) => `
  //             <a href="${p.url}" class="search-popup__suggestion">
  //               ${p.title}
  //             </a>
  //           `
  //       )
  //       .join('');

  //     /* 🔹 BLOGS */
  //     blogsWrap.innerHTML = articles
  //       .map(
  //         (a) => `
  //             <a href="${a.url}" class="search-popup__suggestion">
  //               ${a.title}
  //             </a>
  //           `
  //       )
  //       .join('');
  //   })
  //   .catch(() => {});
  // });
  // Search results

  const input = document.querySelector('.search-popup__input');
  const productsWrap = document.querySelector('.search-popup__products');
  const pagesWrap = document.querySelector('.search-popup__suggestions-page');
  const blogsWrap = document.querySelector('.search-popup__suggestions--blog');

  if (!input) return;

  // 🔹 default content save kar lo
  const defaultProductsHTML = productsWrap.innerHTML;
  const defaultPagesHTML = pagesWrap.innerHTML;
  const defaultBlogsHTML = blogsWrap.innerHTML;

  let controller;

  input.addEventListener('input', () => {
    const q = input.value.trim();

    // 🔹 agar input blank ho jaye → default content wapis
    if (q.length === 0) {
      productsWrap.innerHTML = defaultProductsHTML;
      pagesWrap.innerHTML = defaultPagesHTML;
      blogsWrap.innerHTML = defaultBlogsHTML;
      return;
    }

    // 🔹 choti length par sirf clear karo
    if (q.length < 2) {
      productsWrap.innerHTML = '';
      pagesWrap.innerHTML = '';
      blogsWrap.innerHTML = '';
      return;
    }

    if (controller) controller.abort();
    controller = new AbortController();

    fetch(
      `/search/suggest.json?q=${encodeURIComponent(q)}&resources[type]=product,page,article&resources[limit]=8`,
      { signal: controller.signal }
    )
      .then(res => res.json())
      .then(data => {
        const results = data.resources?.results || {};
        const products = results.products || [];
        const pages = results.pages || [];
        const articles = results.articles || [];

        // PRODUCTS
        productsWrap.innerHTML = products.map(p => `
          <a href="${p.url}" class="search-popup__product">
            ${p.image ? `
              <div class="search-popup__product-image">
                <img src="${p.image}" alt="${p.title}">
              </div>` : ''}
            <span class="search-popup__product-title">${p.title}</span>
          </a>
        `).join('');

        // PAGES
        pagesWrap.innerHTML = pages.map(p => `
          <a href="${p.url}" class="search-popup__suggestion">
            ${p.title}
          </a>
        `).join('');

        // BLOGS
        blogsWrap.innerHTML = articles.map(a => `
          <a href="${a.url}" class="search-popup__suggestion">
            ${a.title}
          </a>
        `).join('');
      })
      .catch(() => {});
  });

  // Newsletter Popup

  // const closeBtn = document.querySelectorAll('.close_popup, .overlay');
  // const overlay = document.querySelector('.overlay');
  // const popup = document.querySelector('.newsletter-popup');

  // const SESSION_KEY = 'newsletter_popup_shown';

  // if (!sessionStorage.getItem(SESSION_KEY)) {
  //   setTimeout(() => {
  //     overlay.classList.add('show');
  //     popup.classList.add('show');
  //     sessionStorage.setItem(SESSION_KEY, 'true');
  //   }, 2500);
  // }

  // closeBtn.forEach(btn => {
  //   btn.addEventListener('click', () => {
  //     overlay.classList.remove('show');
  //     popup.classList.remove('show');
  //   });
  // });

  // Product Card Images Slider

  document.querySelectorAll('.featured-card__image-box-wrapper').forEach(slider => {
    slider.addEventListener('wheel', function(e) {
      if (window.innerWidth > 767) return;
      if (e.deltaY == 0) return;
      e.preventDefault();
      slider.scrollBy({
        left: e.deltaY,
        behavior: 'smooth'
      });
    });
  });

  // Responsive Accordian
  
  // document.querySelectorAll('.mega-menu__item a').forEach(anchor => {
  //   anchor.addEventListener('click', function(e) {
  //     // Prevent default anchor behavior
  //     e.preventDefault();
      
  //     // Find either .mega-menu__list OR .mega-menu__left-detail inside the clicked anchor's parent li
  //     const megaMenuList = this.closest('.mega-menu__item').querySelector('.mega-menu__list') || 
  //                         this.closest('.mega-menu__item').querySelector('.mega-menu__left-detail');
      
  //     if (megaMenuList) {
  //       // Toggle display block/none for the menu list
  //       if (megaMenuList.style.display === 'block') {
  //         megaMenuList.style.display = 'none';
          
  //         // Show .for_open and hide .for_close in the clicked anchor
  //         const forOpen = this.querySelector('.for_open');
  //         const forClose = this.querySelector('.for_close');
          
  //         if (forOpen) forOpen.style.display = 'inline-flex';
  //         if (forClose) forClose.style.display = 'none';
  //       } else {
  //         megaMenuList.style.display = 'block';
          
  //         // Hide .for_open and show .for_close in the clicked anchor
  //         const forOpen = this.querySelector('.for_open');
  //         const forClose = this.querySelector('.for_close');
          
  //         if (forOpen) forOpen.style.display = 'none';
  //         if (forClose) forClose.style.display = 'inline-flex';
  //       }
  //     }
  //   });
  // });
// document.querySelectorAll('.mega-menu__item > .mega-menu__link').forEach(link => {
//   link.addEventListener('click', function (e) {
//     e.preventDefault();

//     const item = this.closest('.mega-menu__item');
//     if (!item) return;

//     const wrap = item.querySelector(
//       '.mega-menu__list-wrap:has(.mega-menu__right-content, .mega-menu__left-detail)'
//     );
//     if (!wrap) return;

//     const isOpen = wrap.style.display === 'block';

//     // pehle sab wraps close karo
//     document.querySelectorAll('.mega-menu__list-wrap').forEach(w => {
//       w.style.display = 'none';
//       const parentLink = w.closest('.mega-menu__item').querySelector('.mega-menu__link');
//       if (parentLink) {
//         const openIcon = parentLink.querySelector('.for_open');
//         const closeIcon = parentLink.querySelector('.for_close');
//         if (openIcon) openIcon.style.display = 'inline-flex';
//         if (closeIcon) closeIcon.style.display = 'none';
//       }
//     });

//     // current item toggle karo
//     wrap.style.display = isOpen ? 'none' : 'block';

//     const forOpen = this.querySelector('.for_open');
//     const forClose = this.querySelector('.for_close');
//     if (forOpen) forOpen.style.display = isOpen ? 'inline-flex' : 'none';
//     if (forClose) forClose.style.display = isOpen ? 'none' : 'inline-flex';
//   });
// });
document.querySelectorAll('.mega-menu__item > .mega-menu__link').forEach(link => {
  const redirectSpan = link.querySelector('span');

  // ✅ span click → redirect allow
  if (redirectSpan) {
    redirectSpan.addEventListener('click', e => {
      e.stopPropagation(); // anchor ka click na chale
      // default allow → redirect ho jaye
    });
  }

  // ✅ anchor click → dropdown logic
  link.addEventListener('click', function (e) {
    const item = this.closest('.mega-menu__item');
    if (!item) return;

    const wrap = item.querySelector(
      '.mega-menu__list-wrap:has(.mega-menu__right-content, .mega-menu__left-detail)'
    );

    // agar dropdown nahi → normal redirect
    if (!wrap) return;

    e.preventDefault();

    const isOpen = wrap.style.display === 'block';

    // sab close
    document.querySelectorAll('.mega-menu__list-wrap').forEach(w => {
      w.style.display = 'none';

      const parentLink = w.closest('.mega-menu__item')?.querySelector('.mega-menu__link');
      parentLink?.querySelector('.for_open')?.style.setProperty('display', 'inline-flex');
      parentLink?.querySelector('.for_close')?.style.setProperty('display', 'none');
    });

    // current toggle
    wrap.style.display = isOpen ? 'none' : 'block';

    this.querySelector('.for_open')?.style.setProperty('display', isOpen ? 'inline-flex' : 'none');
    this.querySelector('.for_close')?.style.setProperty('display', isOpen ? 'none' : 'inline-flex');
  });
});


  // Add To Cart Script

(function () {
  document.addEventListener('click', async function (event) {
    const button = event.target.closest('.add-to-cart');

    if (!button) return;

    event.preventDefault();

    const variantId = button.getAttribute('data-variant-id');
    const confirmationIcon = button.querySelector(
      '.add-to-cart-button__price'
    );

    if (!variantId || button.classList.contains('loading')) return;

    button.classList.add('loading');
    button.disabled = true;

    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({
          id: variantId,
          quantity: 1
        })
      });

      const result = await response.json();

      if (!response.ok) {
        throw new Error(
          result.description || 'Product could not be added.'
        );
      }

      if (
        window.HWBCart &&
        typeof window.HWBCart.open === 'function'
      ) {
        await window.HWBCart.open();
      } else {
        const cartResponse = await fetch('/cart.js');
        const cart = await cartResponse.json();

        document
          .querySelectorAll('.cart-count, [data-cart-count]')
          .forEach(function (counter) {
            counter.textContent = cart.item_count;
            counter.classList.toggle(
              'is-empty',
              cart.item_count === 0
            );
          });

        console.warn(
          'Product added, but the cart drawer script is not installed.'
        );
      }

      if (confirmationIcon) {
        const originalText = confirmationIcon.textContent;

        confirmationIcon.textContent = '✓';

        setTimeout(function () {
          confirmationIcon.textContent = originalText;
        }, 1500);
      }
    } catch (error) {
      console.error('Add to cart error:', error);
      alert(error.message);
    } finally {
      button.classList.remove('loading');
      button.disabled = false;
    }
  });
})();
});